import { GradFairsBannerLoadable } from '#/components/Banners/GradFairsBannerLoadable';
import { MergerBannerLoadable } from '#/components/Banners/MergerBannerLoadable';
import { ResumeDatabaseBannerLoadable } from '#/components/Banners/ResumeDatabaseBannerLoadable';
import { SalarySurveyBannerLoadable } from '#/components/Banners/SalarySurveyBannerLoadable';
import { ClientOnly } from '#/containers/ClientOnly';
import { AdSection } from '#/types/Ads/AdSection';
import { AdType } from '#/types/Ads/AdType';
import { getItem } from '#/utils/localStorage';
import { useAdType } from '#/zustand-stores/adStore';

import { BannerAdsBox } from './BannerAds.styled';

const adComponents = {
  GRAD_FAIRS: GradFairsBannerLoadable,
  SALARY_SURVEY: SalarySurveyBannerLoadable,
  RESUME_DB: ResumeDatabaseBannerLoadable,
  MERGER: MergerBannerLoadable,
};

export function BannerAds() {
  const adType = useAdType(AdSection.BANNER);
  const CurrentAd = adType ? adComponents[adType] : null;

  if (adType === AdType.MERGER || Boolean(getItem('enableBannerAds-2025-6'))) {
    return (
      <BannerAdsBox qaId="ads-container">
        <ClientOnly>{CurrentAd ? <CurrentAd /> : null}</ClientOnly>
      </BannerAdsBox>
    );
  } else return null;
}
